import { useState } from "react";
import { GripVertical, Eye, EyeOff, Trash2, ChevronUp, ChevronDown } from "lucide-react";
import { BLOCK_SCHEMAS } from "@/components/home/pageBlocks";

export const BlockList = ({ blocks, selectedId, onSelect, onChange }) => {
  const [dragId, setDragId] = useState(null);
  const [overId, setOverId] = useState(null);

  const move = (from, to) => {
    if (to < 0 || to >= blocks.length || from === to) return;
    const next = [...blocks];
    const [b] = next.splice(from, 1);
    next.splice(to, 0, b);
    onChange(next);
  };
  const update = (id, patch) => onChange(blocks.map((b) => (b.id === id ? { ...b, ...patch } : b)));
  const remove = (id) => onChange(blocks.filter((b) => b.id !== id));

  const onDrop = (targetId) => {
    if (dragId && dragId !== targetId) {
      move(blocks.findIndex((b) => b.id === dragId), blocks.findIndex((b) => b.id === targetId));
    }
    setDragId(null);
    setOverId(null);
  };

  return (
    <ul className="space-y-1.5" data-testid="editor-block-list">
      {blocks.map((b, i) => {
        const schema = BLOCK_SCHEMAS[b.type] || { label: b.type };
        const active = selectedId === b.id;
        return (
          <li key={b.id} draggable onDragStart={() => setDragId(b.id)} onDragEnd={() => { setDragId(null); setOverId(null); }}
            onDragOver={(e) => { e.preventDefault(); setOverId(b.id); }} onDrop={() => onDrop(b.id)}
            onClick={() => onSelect(b.id)}
            className={`group flex items-center gap-2 px-2 py-2.5 border cursor-pointer select-none transition-[background-color,border-color,opacity] duration-150
              ${active ? "border-[#EFDF00] bg-[#FFFBD6]" : "border-[#E5E5E5] bg-white hover:border-black"}
              ${overId === b.id && dragId !== b.id ? "border-t-4 border-t-black" : ""}
              ${dragId === b.id ? "opacity-40" : ""} ${b.visible === false ? "opacity-60" : ""}`}
            data-testid={`editor-block-${b.id}`}>
            <GripVertical className="w-4 h-4 text-[#888B8D] cursor-grab flex-shrink-0" />
            <div className="flex-1 min-w-0">
              <p className={`text-sm font-bold truncate ${b.visible === false ? "line-through text-[#888B8D]" : "text-black"}`}>{schema.label}</p>
              {!schema.builtin && b.props?.title && <p className="text-xs text-[#888B8D] truncate">{b.props.title}</p>}
            </div>
            <div className="flex items-center opacity-70 group-hover:opacity-100">
              <button type="button" onClick={(e) => { e.stopPropagation(); move(i, i - 1); }} disabled={i === 0}
                className="p-1 hover:bg-[#EFDF00] disabled:opacity-20" aria-label="Nach oben" data-testid={`editor-up-${b.id}`}>
                <ChevronUp className="w-4 h-4" />
              </button>
              <button type="button" onClick={(e) => { e.stopPropagation(); move(i, i + 1); }} disabled={i === blocks.length - 1}
                className="p-1 hover:bg-[#EFDF00] disabled:opacity-20" aria-label="Nach unten" data-testid={`editor-down-${b.id}`}>
                <ChevronDown className="w-4 h-4" />
              </button>
              <button type="button" onClick={(e) => { e.stopPropagation(); update(b.id, { visible: b.visible === false }); }}
                className="p-1 hover:bg-[#EFDF00]" aria-label="Ein-/Ausblenden" data-testid={`editor-visibility-${b.id}`}>
                {b.visible === false ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
              </button>
              <button type="button" onClick={(e) => { e.stopPropagation(); remove(b.id); }}
                className="p-1 hover:bg-red-600 hover:text-white" aria-label="Entfernen" data-testid={`editor-delete-${b.id}`}>
                <Trash2 className="w-4 h-4" />
              </button>
            </div>
          </li>
        );
      })}
    </ul>
  );
};
